import React from 'react';
import './Solutions.css';

const Solutions = () => {
  const solutions = [
    {
      number: '01',
      title: 'Identify Core Challenges',
      description: 'We conduct thorough analysis to understand your unique pain points, market position, and operational challenges. Our diagnostic approach ensures we address root causes, not just symptoms.'
    },
    {
      number: '02',
      title: 'Design Custom Solutions',
      description: 'Every business is unique. We craft tailored solutions that align with your goals, whether that means developing custom technology, redesigning processes, or creating innovative strategies.'
    },
    {
      number: '03',
      title: 'Implement & Optimize',
      description: 'We don\'t just deliver recommendations—we work alongside you to implement solutions, monitor results, and continuously optimize for maximum impact and ROI.'
    }
  ];

  return (
    <section id="solutions" className="solutions">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How We Better Your Business</h2>
        </div>
        <div className="solutions-content">
          {solutions.map((solution, index) => (
            <div key={index} className="solution-item">
              <div className="solution-number">{solution.number}</div>
              <div className="solution-text">
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;

